export const normalizeString = (string: string) => string.trim().toLowerCase();
